import { NgZone, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { isE2E } from '../utils';
import { isPlatformBrowser } from '@angular/common';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
// type Params = Parameters<typeof Router['routerNavigateTo']>;
export let E2eNavigationModule = /*#__PURE__*/(() => {
  class E2eNavigationModule {
    constructor(router, zone, platformId) {
      this.router = router;
      this.zone = zone;
      this.platformId = platformId;
      this.enable = IS_SERVED || isE2E();
      if (isPlatformBrowser(this.platformId) && this.enable) {
        this.exposeRouterNavigation();
      }
    }
    exposeRouterNavigation() {
      window.routerNavigateTo = (url, extras) => {
        this.zone.run(() => {
          console.log("navigating to " + url);
          this.router.navigateByUrl(url, extras);
        });
      };
    }
    static {
      this.ɵfac = function E2eNavigationModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || E2eNavigationModule)(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i0.NgZone), i0.ɵɵinject(PLATFORM_ID));
      };
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: E2eNavigationModule
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({});
    }
  }
  return E2eNavigationModule;
})();